<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="订单号:" prop="orderNo">
                <el-input clearable placeholder="请输入" v-model="searchForm.orderNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" v-if="companyType === '1'">
              <el-form-item label="分公司:">
                <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                  <el-option
                    v-for="item in belongCompanyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="代理商:" prop="companyId">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.companyId"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in agentData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单完成时间:">
                <custom-date-range
                  :start-date="searchForm.startTime"
                  :end-date="searchForm.endTime"
                  @update:startDate="(val) => (searchForm.startTime = val)"
                  @update:endDate="(val) => (searchForm.endTime = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
                <el-button type="default" @click="handleSet()">生成结算单</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="true"
        @selectionChange="handleSelectionChange"
        @pagination="handleSizeChange">
        <template v-slot:orderNo="{ row }">
          <span class="cursor color1966ff" @click="handleDetail(row)">{{row.orderNo}}</span>
        </template>
        <template v-slot:startProvinceName="{ row }">
          <div>起：{{row.startProvinceName}}{{row.startCityName}}{{row.startDistrictName}}</div>
          <div>止：{{row.endProvinceName}}{{row.endCityName}}{{row.endDistrictName}}</div>
        </template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="handleDelete(row.orderId)">删除</span>
        </template>
      </custom-table>
    </div>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import detail from "@/views/OrderManagement/detail.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import {numberToThousand} from "@/utils/tool"
import { getPage, reconciliationOrder } from "./api";
import { getSelectAgent } from "@/views/SystemManagement/AgentManagement/api";
import { reconcile } from "@/views/FinancialManagement/ReconciliationBill/statementAccount/api";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    OperateBox,
    CustomTable,
    detail,
    CustomDateRange,
  },
  data() {
    return {
      getTableMethod: getPage,

      searchForm: {
        "belongCompanyId": "",
        "companyId": "",
        "endTime": "",
        "orderNo": "",
        "startTime": ""
      },
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      tableColumn: [
        {
          label: "订单号",
          prop: "orderNo",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "代理商",
          prop: "agentCompanyName",
          align: "left",
          show: true,
        },
        {
          label: "运输线路",
          prop: "startProvinceName",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "货主姓名",
          prop: "ownerName",
          align: "left",
          show: true,
        },
        {
          label: "货主手机号",
          prop: "ownerPhone",
          align: "left",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "driverName",
          align: "left",
          show: true,
        },
        {
          label: "司机手机号",
          prop: "driverPhone",
          align: "left",
          show: true,
        },
      ],
      agentData: [],
      reconciliationStatusData: [
        {
          label: '未出账',
          value: 1,
        },
        {
          label: '已出账',
          value: 0,
        }
      ],
      selectRows: []
    };
  },
  watch: {
    "searchForm.belongCompanyId":function(val) {
      this.searchForm.companyId = ""
      this.getAgentData(val)
    }
  },
  created() {
    // this.getAgentData()
  },
  mounted() {
  },
  methods: {
    numberToThousand,
    getAgentData(val) {
      getSelectAgent({
        belongCompanyId: val,
        keyword: ''
      }).then(response => {
        if (response.code === 200) {
          this.agentData = response.data
        }
      })
    },
    handleSet() {
      if (this.selectRows.length === 0) {
        this.$message.warning("请选择订单")
        return
      } else {
        this.setOrder(this.selectRows)
      }
    },
    handleSelectionChange(rows) {
      this.selectRows = [...rows]
    },
    setOrder(row) {
      this.$confirm(`确定生成结算单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        reconciliationOrder({
          orderIds: row.map(item => item.orderId),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("结算单已生成")
            this.tableOptions.pageNumber = 1;
            this.getTableData();
          }
        });
      });
    },
    handleDelete(id, msg = "此操作将删除该数据, 是否继续?") {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(() => {
        this.deleteMethod(id).then((res) => {
          if (res.code === 200) {
            this.handleOtherOperate();
            this.getTableData();
          }
        });
      });
    },
    handleDownload() {
      this.$message.warning("功能等超超")
    },
    handleDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }

  .search-table-box {
    display: flex;
    margin: 0.16rem -0.1rem 0;

    .list-box {
      width: 33.33%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;

      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }

      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }

  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .custom-table-box {
    padding-top: 0;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
